export default __webpack_public_path__ + "static/media/black-pantsuit.b4f0ba93.jpg";